import { gql } from 'apollo-boost';

// Shared by the root store action (used by category-picker dropdowns across the app) and the
// namespaced categories module (used by the Categories management page), so the two don't drift.
export const GET_CATEGORIES_FOR_MANAGEMENT_QUERY = gql`
  query getCategoriesForManagement($input: GetCategoriesInput!) {
    getCategories(input: $input) {
      items {
        id
        name
        description
        categoryType
        procedureCount
        createdAt
      }
      pager {
        limit
        offset
        count
      }
    }
  }
`;
